const supportApiEndpoints = {
    notificationOptions: '/spp/announcements',
    circulationOptions: '/spp/circulations',
};

export default supportApiEndpoints;
